<script>
  import Layout from "../../Layout/Layout.svelte";
  import config from "../../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import CustomerRow from "./CustomerRow.svelte";
  import { Circle } from "svelte-loading-spinners";
  import { link } from "svelte-spa-router";
  import MenuHeading from "../../shared/MenuHeading.svelte";

  let customers = null;
  let queryURL = "";

  let page = 1;
  let searchKey = "";

  const fetchCustomers = () => {
    customers = null;

    queryURL = `${$config.backendURL}/customers/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;

    axios
      .get(queryURL)
      .then((res) => {
        customers = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchCustomers();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchCustomers();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = "";
    fetchCustomers();
  };

  onMount(() => {
    fetchCustomers();
  });
</script>

<svelte:head>
  <title>Customers | Fabi CC System</title>
</svelte:head>

<Layout>
  {#if $config.currentUser}
    {#if $config.currentUser.department == "Management"}
      <MenuHeading title="Customers" description="Manage Customers here..." />

      <!-- Search Bar -->
      <div class="flex justify-between">
        <div class="flex justify-center">
          <input
            bind:value={searchKey}
            on:input={fetchCustomers}
            class="shadow-sm"
            type="text"
            placeholder="Enter an customer..."
          />
          <button class="ml-2 btn btn-green" on:click={fetchCustomers}>
            <i class="fas fa-search" />
          </button>
        </div>
        <div class="flex items-center">
          <button class="btn btn-blue mr-4" on:click={handleRefresh}>
            <i class="fas fa-undo mr-3" />
            Refresh
          </button>
          <a class="btn btn-green" use:link href="/addcustomer">
            <i class="fas fa-plus-circle mr-3" />
            Add Customer
          </a>
        </div>
      </div>

      <!-- Products Bar -->
      <div
        class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
      >
        <div
          class="th tracking-wider border-b border-gray-100 font-semibold text-gray-600"
        >
          <h1 style="min-width: 10rem; max-width: 10rem;">Actions</h1>
          <h1 style="min-width: 17.5rem; max-width: 17.5rem;">
            Contact Person
          </h1>
          <h1 style="min-width: 10rem; max-width: 10rem;">Telephone</h1>
          <div style="min-width: 15rem; max-width: 15rem;">Email</div>
          <div style="min-width: 7.5rem; max-width: 7.5rem;">Type</div>
          <div style="min-width: 22.5rem; max-width: 22.5rem;">
            Company Name
          </div>
        </div>

        {#if customers}
          {#each customers as customer (customer._id)}
            <CustomerRow {...customer} on:delete={fetchCustomers} />
          {:else}
            <div class="h-52 w-full flex items-center justify-center">
              Nothing to show...
            </div>
          {/each}
        {:else}
          <div class="h-52 w-full flex items-center justify-center">
            <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
          </div>
        {/if}

        <div class="tf">
          <button
            class="text-base btn btn-gray-outline"
            on:click={handlePrevPage}
          >
            <i class="fas fa-arrow-circle-left mr-3" />
            Prev Page
          </button>
          <div class="mx-4">Page {page}</div>
          <button
            class="text-base btn btn-gray-outline"
            on:click={handleNextPage}
          >
            Next Page
            <i class="fas fa-arrow-circle-right ml-3" />
          </button>
        </div>
      </div>
    {/if}
  {/if}
</Layout>

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
